import { Component, output, signal } from '@angular/core';
import { DsButtonModule, DsModalModule } from '@bmw-ds/components';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pure-legal-notice-modal',
  imports: [DsModalModule, TranslateModule, DsButtonModule],
  templateUrl: './legal-notice-modal.component.html',
  styleUrl: './legal-notice-modal.component.scss',
})
export class LegalNoticeModalComponent {
  modalIsOpen = signal<boolean>(true);
  closed = output<void>();

  modalDismissed(): void {
    this.modalIsOpen.set(false);
    this.closed.emit();
  }

}
